import { useSplide } from "~/lib/splide"

document.addEventListener('DOMContentLoaded', () => {
  useSplide('[data-testimonial-slider]', {
    perPage: 3,
    gap: '2rem',
    autoplay: true,
    perMove: 1,
    rewind: true,
    pagination: false,
    padding: {
      left: '10%',
      right: '10%'
    },
    breakpoints: {
      767: {
        perPage: 1,
        gap: '1rem',
        perMove: 1,
        padding: {
          left: '3%',
          right: '20%'
        }
      }
    },
  })
    ?.then((splide) => {
      splide?.mount()
    })
})